import { render } from "./MagicShop.vue?vue&type=template&id=825ef224&scoped=true"
import script from "./MagicShop.vue?vue&type=script&lang=js"
export * from "./MagicShop.vue?vue&type=script&lang=js"

import "./MagicShop.vue?vue&type=style&index=0&id=825ef224&lang=scss&scoped=true"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825ef224"]])

export default __exports__